module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "VPS-3"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "toc-title"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Contents")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-fm11"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/005_Introduction"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Introduction")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-fm11"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/006_Acknowledgements"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Acknowledgements")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/007_Chapter_1"
    }
  }, [_vm._v("Chapter One")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-fm1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/007_Chapter_1"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Early Development")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-fm"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/008_Chapter_2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Two")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-fm1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/008_Chapter_2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Interwar Destroyers")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-fm"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/009_Chapter_3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Three")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-fm1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/009_Chapter_3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Second World War Destroyers")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-fm"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/010_Chapter_4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Four")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-fm1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/010_Chapter_4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Cold War Destroyers")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-fm"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/011_Chapter_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Five")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-fm1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/011_Chapter_5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Post-Cold War Destroyers")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a01b224c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/toc.vue
// module id = 63
// module chunks = 0